import type { PropsWithChildren } from "react"

/**
 * OKS-21 — PublicLayout for unauthenticated landing surfaces.
 *
 * Mounted by `pages/Public/InviteLanding.tsx`. **No** sidebar, no auth
 * nav, no `Current` provider — those live in `AppLayout` /
 * `AuthLayout` which assume an authenticated user. The public landing
 * is reached anonymously via `/i/:token`; assuming any auth context
 * would crash on first render.
 *
 * Mobile-first reference: 402px (OKS-457 V2 — bumped from the OKS-21
 * 390px). On wider viewports the content centers with a soft max width;
 * the cover/hero band stays full-bleed edge-to-edge for visual impact
 * (no width clamp — the cover spans the full viewport).
 *
 * `<PersistentLayout>` (sonner Toaster + flash bridge) is mounted by
 * Vite's Inertia setup callback, NOT here — so toasts work on the
 * public landing too even though we don't render `<Toaster>` again.
 */
export default function PublicLayout({ children }: PropsWithChildren) {
  return (
    <div className="bg-background flex min-h-svh flex-col">
      <main
        className="flex flex-1 flex-col"
        // Inertia visits stamp <main> as the page-level landmark.
        // Public landing surfaces are intentionally minimal — no
        // skip-nav link needed (no nav exists to skip).
      >
        {children}
      </main>
    </div>
  )
}
